import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Seva Sethu Privacy Policy content
const fallbackPrivacyPolicy = `
*Last updated: December 2024*

## Introduction

Seva Sethu Marketplace ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or make a purchase.

## Information We Collect

**Personal Information:** When you make a purchase or create an account, we collect:
- Name and contact information
- Billing and shipping addresses
- Payment information (processed securely through our payment providers)
- Email address
- Phone number (optional)

**Automatically Collected Information:** We may collect information about your device, browser, IP address, and browsing behavior on our site.

## How We Use Your Information

- Process and fulfill your orders
- Communicate with you about your orders and account
- Send promotional emails (with your consent)
- Improve our website and services
- Prevent fraud and ensure security

## Information Sharing

We may share your information with:
- Sellers on our marketplace to fulfill your orders
- Payment processors to complete transactions
- Shipping carriers to deliver your orders
- Service providers who assist our operations

**We do not sell your personal information to third parties.**

## Your Rights

You have the right to:
- Access your personal information
- Correct inaccurate information
- Request deletion of your information
- Opt out of marketing communications

## Contact Us

If you have questions about this Privacy Policy, please contact us at support@seva-sethu.com.
`;

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'privacy',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Privacy Policy' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackPrivacyPolicy,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Privacy Policy | Seva Sethu',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Privacy Policy for Seva Sethu Marketplace - How we collect, use, and protect your information.',
    },
  },
};

// This is the fallback page, in case there's no Privacy Policy asset defined in Console.
const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
